module.exports = __webpack_public_path__ + "static/media/promo-banner-tablet.ce555d89.webp";